export default __webpack_public_path__ + "static/media/mod_OP_ITA.7be7064c.jpg";